/**
 * El backend rechaza cobrar la orden completa cuando ya tiene la cuenta
 * dividida, y lo hace desde cuatro lugares: el cobro manual
 * (OrderService.ProcessPaymentAsync) y la creación del intent de terminal en
 * MercadoPagoPointService y GetnetPointService. Todos responden el mismo texto.
 *
 * Se compara por texto porque el backend no expone un código de error. Si algún
 * día lo expone, este es el único punto a cambiar — por eso no se repite el
 * `includes` en cada pantalla.
 */
export const isOrderAlreadySplitError = (error: unknown): boolean => {
  const candidate = error as { data?: { message?: string }; message?: string } | undefined;
  const backendMessage = candidate?.data?.message ?? candidate?.message;
  return typeof backendMessage === 'string' && backendMessage.includes('cuenta dividida');
};

/** Aviso único para ese caso, para que las tres pantallas digan lo mismo. */
export const ORDER_ALREADY_SPLIT_NOTICE =
  'Esta orden ya tiene la cuenta dividida; se cobra cuenta por cuenta.';
